import Types from './convsArchive.types';

export const fetchConvsArchiveList = (data, setLoading) => ({
  type: Types.FETCH_CONVS_ARCHIVE_LIST,
  payload: { data, setLoading },
});

export const setConvsArchiveList = (data) => ({
  type: Types.SET_CONVS_ARCHIVE_LIST,
  payload: data,
});

export const setConvsArchiveListLoading = (isLoading) => ({
  type: Types.SET_LOADING_CONVS_ARCHIVE_LIST,
  payload: isLoading,
});

export const fetchUserConvsArchiveDetails = (convId) => ({
  type: Types.FETCH_USER_CONVS_ARCHIVE_DETAILS,
  payload: convId,
});

export const setUserConvsArchiveDetails = (data) => ({
  type: Types.SET_USER_CONVS_ARCHIVE_DETAILS,
  payload: data,
});

export const openConversationForTheUser = (convId) => ({
  type: Types.OPEN_CONVERSATION_FROM_ARCHIVE,
  payload: convId,
});

export const updateUserAbout = ({ userId, about }) => ({
  type: Types.UPDATE_USER_ABOUT,
  payload: { userId, about },
});

export const exportConvsList = (data) => ({
  type: Types.EXPORT_CONVS_LIST,
  payload: data,
});

export const exportExcelChatsList = (params) => ({
  type: Types.EXPORT_EXCEL_BASED_ON_PACKAGE,
  payload: params,
});
